<template lang="">
  <div
    v-show="isVisibility"
    :class="[
      'ms-tracking-box',
      isExpand ? '' : 'collapse'
    ]"
  >
    <div class="ms-tracking-box__header">
      <div
        class="header__title"
        @click="test"
      >
        {{ title }}
      </div>
      <div
        :class="[
          'header__expand-button icon20',
          isExpand ? 'expand' : 'collapse'
        ]"
        @click="toggle"
      />
    </div>
    <transition-group
      ref="trackingList"
      name="tracking-list"
      tag="div"
      class="ms-tracking-box__content"
    >
      <ms-tracking-item
        v-for="trackingItem in trackingItems"
        :key="trackingItem.id"
        :tracking-id="trackingItem.id"
        :event-id="trackingItem.eventId"
        :title="trackingItem.title"
        :status="trackingItem.status"
        :show-close="trackingItem.showClose"
        :interval-time="trackingItem.intervalTime"
        :listener="(data) => trackingItem.listener(data, trackingItem)"
        :interval-handler="() => trackingItem.intervalHandler(trackingItem)"
        @close="onClose(trackingItem)"
      />
    </transition-group>
  </div>
</template>

<script>
import {
  computed,
  ref,
  reactive,
  nextTick,
} from 'vue'

import MsTrackingItem from './TrackingItem'
import i18n from '@/i18ns/i18n'

export default {
  name: 'MsTrackingBox',

  components: {
    MsTrackingItem,
  },

  props: {
    hideIfEmpty: {
      type: Boolean,
      default: true,
    },
  },

  setup (props, { emit }) {
    const trackingItems = reactive([])
    const isExpand = ref(true)
    const trackingList = ref(null)
    const numItem = computed(() => {
      return trackingItems?.length || 0
    })
    const isVisibility = computed(() => {
      return numItem.value || !props.hideIfEmpty
    })

    const title = computed(() => {
      return i18n.global.t('i18nComponent.TrackingBox.Header', { num: numItem.value })
    })

    const toggle = () => {
      isExpand.value = !isExpand.value
    }

    const onClose = (trackingItem) => {
      const trackingIndex = trackingItems.findIndex(item => item === trackingItem)

      if (trackingIndex >= 0) {
        trackingItems.splice(trackingIndex, 1)
      }

      if (typeof trackingItem?.onClose === 'function') {
        trackingItem.onClose()
      }
    }

    // const onSuccess = (trackingItem) => {
    //   if (typeof trackingItem?.onSuccess === 'function') {
    //     trackingItem.onSuccess()
    //   }
    // }

    // const onError = (trackingItem) => {
    //   if (typeof trackingItem?.onError === 'function') {
    //     trackingItem.onError()
    //   }
    // }

    /**
     * @author PVThang
     * @description thêm item
     * {
        id: 1,
        title: 'Gửi mail yêu cầu xác thực tài khoản', // Title hiển thị
        showClose: true, // có show close hay không
        status: TrackingStatus.Processing, // Trạng thái hiện tại
        onClose: () => {}, // callback khi close
        eventId: "", // eventId để lắng nghe socket
        listener: (data, item) => {}, // callback lắng nghe socket
        intervalTime: 0, // nếu muốn ping lên server để kiểm tra trạng thái
        intervalHandler: (item) => {}, // hàm xử lý interval
      },
     */
    const add = (payload) => {
      trackingItems.push(payload)

      nextTick(() => {
        const scrollTop = trackingList.value.$el.scrollHeight - trackingList.value.$el.clientHeight
        if (scrollTop > 0) {
          trackingList.value.$el.scrollTo({
            top: scrollTop,
            behavior: 'smooth',
          })
        }
      })
    }

    return {
      isExpand,
      title,
      isVisibility,
      trackingItems,
      toggle,
      onClose,
      // onSuccess,
      // onError,
      add,
      trackingList,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsTrackingBox.scss';

.tracking-list-move,
.tracking-list-enter-active,
.tracking-list-leave-active {
  transition: all 0.25s ease;
}
.tracking-list-enter-from,
.tracking-list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
